// FICHIER : frontend/src/pages/LandingPage.jsx
import { BRAND } from '../constants/brand';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import NavLogo from '../components/NavLogo';
import axios from 'axios';

const API = 'https://ark-recruitment-backend.onrender.com/api';

// ── Icônes ──
const IconArrow = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);
const IconBriefcase = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
  </svg>
);

// ── Offres de démonstration ──
const OFFRES_DEMO = [
  { id:'demo-1', titre:'Développeur Full Stack',                    salaire:'800k – 1,5M FCFA/mois', tags:['Télétravail','Tech','React · Node'],  urgence:'Urgent',  annonce_complete:'Rejoignez notre équipe technique pour développer et maintenir notre plateforme de recrutement IA.' },
  { id:'demo-2', titre:'Analyste Financier Senior',                 salaire:'1M – 2M FCFA/mois',     tags:['Télétravail','Présentiel','Finance'], urgence:'Normal',  annonce_complete:'Pilotez nos analyses financières et contribuez à la stratégie de croissance de nos clients.' },
  { id:'demo-3', titre:'Expert Juridique',                          salaire:'1,2M – 2,5M FCFA/mois', tags:['Télétravail','Droit','Contrats'],    urgence:'Normal',  annonce_complete:'Assurez la conformité juridique et la rédaction de contrats pour nos entreprises partenaires.' },
  { id:'demo-4', titre:'Expert Python / Intelligence Artificielle', salaire:'900k – 1,5M FCFA/mois', tags:['Télétravail','IA','Python · ML'],    urgence:'Urgent',  annonce_complete:'Développez et optimisez nos modèles IA pour automatiser et améliorer le processus de recrutement.' },
  { id:'demo-5', titre:'Responsable RH Senior',                     salaire:'700k – 1,2M FCFA/mois', tags:['Présentiel','Ressources Humaines'],  urgence:'Normal',  annonce_complete:'Coordonnez les processus RH et accompagnez nos clients dans leur stratégie de recrutement.' },
  { id:'demo-6', titre:'Comptable & Auditeur Expert',               salaire:'600k – 1M FCFA/mois',   tags:['Télétravail','Présentiel','Audit'],  urgence:'Normal',  annonce_complete:'Gérez la comptabilité et les audits financiers pour garantir la conformité de nos partenaires.' },
];

// ── Données des fonctionnalités ──
const FEATURES = [
  { titre:'ADN Marque Employeur',     desc:"Définissez mission, vision, valeurs et EVP en quelques minutes grâce à un assistant IA guidé étape par étape." },
  { titre:'Entretien IA en 4 phases', desc:"Profilage, comportemental, technique et cognitif — conduits automatiquement, sans intervention humaine." },
  { titre:'Rapports détaillés',       desc:"Chaque candidat analysé en profondeur. Scores, recommandations et analyse comportementale livrés automatiquement." },
  { titre:'Génération de contenu RH', desc:"Posts LinkedIn, offres d'emploi, scripts WhatsApp — votre contenu RH généré automatiquement en un clic." },
  { titre:'Score marque employeur',   desc:"Mesurez votre attractivité sur 100 et recevez des axes d'amélioration concrets et actionnables." },
  { titre:'Marchés émergents',        desc:"Conçu pour les entreprises africaines. Interface simple, sans barrière technique, opérationnel en 10 minutes." },
];

// ── Données des étapes ──
const STEPS = [
  { n:'1', titre:'Construisez votre marque', desc:"Répondez à quelques questions. L'IA génère votre ADN employeur complet — mission, valeurs, EVP — en moins de 10 minutes." },
  { n:'2', titre:'Publiez vos offres',       desc:"Créez vos annonces en quelques secondes. Elles sont optimisées automatiquement pour attirer les bons profils." },
  { n:'3', titre:'Recevez vos rapports',     desc:"L'IA conduit les entretiens en 4 phases et vous livre un rapport complet sur chaque candidat. Vous n'avez plus qu'à décider." },
];

// ── Composant principal Landing Page ──
export default function LandingPage() {
  const navigate = useNavigate();

  // ── Détection mobile ──
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handle = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handle);
    return () => window.removeEventListener('resize', handle);
  }, []);

  // ── Chargement offres depuis Supabase ──
  const [OFFRES, setOffres] = useState(OFFRES_DEMO);
  useEffect(() => {
    axios.get(`${API}/offres/publiques`).then(res => {
      if (res.data && res.data.length > 0) {
        setOffres(res.data.slice(0, 6).map(o => ({ ...o, tags: o.tags || [], urgence: o.urgence || 'Normal', annonce_complete: o.annonce_complete || '' })));
      }
    }).catch(() => {});
  }, []);

  // ── Paddings responsives réutilisables ──
  const pSection      = isMobile ? '40px 20px' : '60px 64px';
  const pSectionInner = isMobile ? '40px 20px' : '0 64px';

  return (
    <div style={{ background:'var(--bg)', color:'var(--text)', fontFamily:'DM Sans,sans-serif', overflowX:'hidden' }}>

      {/* ── NAVIGATION ── */}
      <nav style={{ position:'sticky', top:0, zIndex:200, display:'flex', alignItems:'center', justifyContent:'space-between', padding: isMobile ? '0 20px' : '0 64px', height:68, background:'var(--nav-bg)', borderBottom:'1px solid var(--border)' }}>
        <NavLogo/>

        {/* Liens nav — centrés, masqués sur mobile */}
        {!isMobile && (
          <div style={{ position:'absolute', left:'50%', transform:'translateX(-50%)', display:'flex', gap:32 }}>
            {[
              { label:'Fonctionnalités', path:'/fonctionnalites' },
              { label:'Comment ça marche', path:'/comment-ca-marche' },
              { label:'Contact', path:'/contact' },
            ].map(l => (
              <span key={l.label} onClick={() => navigate(l.path)} style={{ color:'var(--muted)', fontSize:14, fontWeight:500, cursor:'pointer' }}>{l.label}</span>
            ))}
          </div>
        )}

        {/* Bouton Créer ma marque employeur — actif, redirige vers /entreprise */}
        <span
          onClick={() => navigate('/entreprise')}
          style={{ background:'var(--accent)', color:'#fff', padding: isMobile ? '8px 16px' : '9px 22px', borderRadius:8, fontSize: isMobile ? 12 : 13, fontWeight:500, display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer', whiteSpace:'nowrap' }}
        >
          {isMobile ? 'Espace entreprise' : 'Créer ma marque employeur'} <IconArrow/>
        </span>
      </nav>

      {/* ── HERO ── */}
      <section style={{ minHeight:'60vh', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', textAlign:'center', padding: isMobile ? '60px 20px 20px' : '60px 20px 0px', position:'relative', overflow:'hidden' }}>

        {/* Lueur de fond */}
        <div style={{ position:'absolute', top:'10%', left:'50%', transform:'translateX(-50%)', width:900, height:600, pointerEvents:'none', background:`radial-gradient(ellipse, var(--hero-glow) 0%, transparent 68%)` }}/>

        {/* Grille de fond */}
        <div style={{ position:'absolute', inset:0, pointerEvents:'none', backgroundImage:`linear-gradient(var(--hero-grid) 1px, transparent 1px),linear-gradient(90deg,var(--hero-grid) 1px,transparent 1px)`, backgroundSize:'60px 60px', WebkitMaskImage:'radial-gradient(ellipse 80% 60% at 50% 40%,black,transparent)' }}/>

        {/* Badge "Nouvelle génération" */}
        <div style={{ position:'relative', zIndex:1, display:'inline-flex', alignItems:'center', gap:8, border:'1px solid var(--border)', background:'var(--hero-badge)', padding:'6px 16px', borderRadius:100, marginBottom:20, fontSize:12, color:'var(--accent2)', fontWeight:500 }}>
          <span style={{ width:6, height:6, borderRadius:'50%', background:'var(--accent2)', animation:'blink 2s infinite', display:'inline-block' }}/>
          Plateforme de recrutement IA — Nouvelle génération
        </div>

        {/* Titre principal */}
        <h1 style={{ position:'relative', zIndex:1, fontFamily:'Syne,sans-serif', fontSize: isMobile ? 'clamp(28px,8vw,38px)' : 'clamp(24px,3vw,42px)', fontWeight:800, lineHeight:1.1, letterSpacing: isMobile ? '-1px' : '-2.5px', maxWidth:920, margin:'0 auto 16px' }}>
          Recrutez <span style={{ color:'var(--accent)' }}>mieux</span>,<br/>avec l'intelligence artificielle
        </h1>

        {/* Description */}
        <p style={{ position:'relative', zIndex:1, fontSize: isMobile ? 15 : 17, color:'var(--muted)', maxWidth:500, margin:'0 auto 28px', lineHeight:1.75, fontWeight:300 }}>
          {BRAND.description}
        </p>

        {/* Boutons CTA */}
        <div style={{ position:'relative', zIndex:1, display:'flex', flexDirection: isMobile ? 'column' : 'row', gap:12, justifyContent:'center', alignItems:'center', width: isMobile ? '100%' : 'auto' }}>

          {/* Bouton entreprise — actif, redirige vers /entreprise */}
          <span onClick={() => navigate('/entreprise')} style={{ background:'var(--accent)', color:'#fff', padding:'14px 28px', borderRadius:10, fontSize:15, fontWeight:500, display:'inline-flex', alignItems:'center', gap:8, width: isMobile ? '90%' : 'auto', justifyContent:'center', cursor:'pointer' }}>
            {BRAND.cta}
          </span>

          {/* Bouton candidat — actif */}
          <span onClick={() => navigate('/offres')} style={{ background:'transparent', color:'var(--text)', padding:'14px 28px', borderRadius:10, fontSize:15, fontWeight:500, border:'1px solid var(--border)', display:'inline-flex', alignItems:'center', gap:8, width: isMobile ? '90%' : 'auto', justifyContent:'center', cursor:'pointer' }}>
            <IconBriefcase/> Voir les offres
          </span>
        </div>
      </section>

      {/* ── STATS ── */}
      <div style={{ display:'flex', flexWrap:'wrap', borderTop:'1px solid var(--border)', borderBottom:'1px solid var(--border)', background:'var(--bg2)' }}>
        {[
          {n:'2 400+', l:'Candidats actifs'},
          {n:'180+',   l:'Entreprises clientes'},
          {n:'94 %',   l:'Taux de satisfaction'},
          {n:'48 h',   l:'Délai moyen de recrutement'}
        ].map((s,i) => (
          <div key={s.n} style={{ flex:'1 1 50%', maxWidth: isMobile ? '50%' : '25%', textAlign:'center', padding:'14px 10px', borderRight: isMobile ? (i%2===0 ? '1px solid var(--border)' : 'none') : (i<3 ? '1px solid var(--border)' : 'none'), borderBottom: isMobile ? (i<2 ? '1px solid var(--border)' : 'none') : 'none' }}>
            <div style={{ fontFamily:'Syne,sans-serif', fontSize: isMobile ? 'clamp(20px,6vw,28px)' : 'clamp(22px,3vw,34px)', fontWeight:800, lineHeight:1, background:'linear-gradient(135deg,var(--accent2),var(--accent))', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', whiteSpace:'nowrap' }}>{s.n}</div>
            <div style={{ color:'var(--muted)', fontSize: isMobile ? 11 : 13, marginTop:4 }}>{s.l}</div>
          </div>
        ))}
      </div>

      {/* ── OFFRES ── */}
      <div style={{ background:'var(--bg)' }}>
        <div style={{ padding: pSection, maxWidth:1240, margin:'0 auto' }}>

          {/* Label section */}
          <div style={{ display:'inline-flex', alignItems:'center', gap:8, color:'var(--accent2)', fontSize:11, fontWeight:600, letterSpacing:2, textTransform:'uppercase', marginBottom:14 }}>
            <span style={{ width:24, height:1, background:'var(--accent2)', display:'inline-block' }}/> Opportunités
          </div>
          <h2 style={{ fontFamily:'Syne,sans-serif', fontSize:'clamp(18px,2vw,26px)', fontWeight:800, lineHeight:1.1, letterSpacing:'-1.2px', marginBottom:24 }}>
            Dernières offres disponibles
          </h2>

          {/* Grille des offres */}
          <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill,minmax(320px,1fr))', gap:14 }}>
            {OFFRES.map(o => (
              <div key={o.id} style={{ background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding:'20px', display:'flex', flexDirection:'column', gap:12 }}>

                {/* Titre + Salaire */}
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:8, flexWrap:'wrap' }}>
                  <div style={{ fontFamily:'Syne,sans-serif', fontSize:14, fontWeight:700, lineHeight:1.35 }}>{o.titre}</div>
                  <div style={{ fontFamily:'Syne,sans-serif', fontSize:11, fontWeight:700, color:'var(--accent2)', background:'var(--salary-bg)', padding:'4px 8px', borderRadius:6 }}>{o.salaire}</div>
                </div>

                {/* Tags */}
                <div style={{ display:'flex', gap:6, flexWrap:'wrap' }}>
                  {o.urgence === 'Urgent' && (
                    <span style={{ fontSize:11, fontWeight:600, padding:'3px 8px', borderRadius:5, border:'1px solid var(--tag-orange-border)', color:'var(--tag-orange)', background:'var(--tag-orange-bg)' }}>
                      Urgent
                    </span>
                  )}
                  {(o.tags || []).map(t => (
                    <span key={t} style={{ fontSize:11, fontWeight:500, padding:'3px 8px', borderRadius:5, border:'1px solid var(--border)', color:'var(--tag-default)' }}>{t}</span>
                  ))}
                </div>

                {/* Aperçu mission — 2 lignes max */}
                <div style={{ fontSize:12, color:'var(--muted)', lineHeight:1.6, overflow:'hidden', display:'-webkit-box', WebkitLineClamp:2, WebkitBoxOrient:'vertical' }}>
                  {o.annonce_complete || ''}
                </div>

                {/* Bas de carte — bouton postuler */}
                <div style={{ display:'flex', justifyContent:'flex-end', borderTop:'1px solid var(--border)', paddingTop:12, marginTop:'auto' }}>
                  <span onClick={() => navigate('/candidature', { state: { offre: o } })} style={{ background:'var(--accent)', color:'#fff', padding:'6px 14px', borderRadius:7, fontSize:12, fontWeight:500, display:'inline-flex', alignItems:'center', gap:6, cursor:'pointer' }}>
                    Postuler <IconArrow/>
                  </span>
                </div>

              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── FONCTIONNALITÉS ── */}
      <div style={{ background:'var(--bg2)', padding: isMobile ? '40px 0' : '60px 0' }}>
        <div style={{ padding: pSectionInner, maxWidth:1240, margin:'0 auto' }}>
          <div style={{ display:'inline-flex', alignItems:'center', gap:8, color:'var(--accent2)', fontSize:11, fontWeight:600, letterSpacing:2, textTransform:'uppercase', marginBottom:14 }}>
            <span style={{ width:24, height:1, background:'var(--accent2)', display:'inline-block' }}/> Fonctionnalités
          </div>
          <h2 style={{ fontFamily:'Syne,sans-serif', fontSize:'clamp(18px,2vw,26px)', fontWeight:800, lineHeight:1.1, letterSpacing:'-1.2px', marginBottom:24 }}>
            Tout ce dont vous avez besoin pour recruter
          </h2>
          <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill,minmax(300px,1fr))', gap:2, background:'var(--border)', border:'1px solid var(--border)', borderRadius:16, overflow:'hidden' }}>
            {FEATURES.map(f => (
              <div key={f.titre} style={{ background:'var(--bg3)', padding: isMobile ? '24px 20px' : '36px 30px', display:'flex', flexDirection:'column', gap:10 }}>
                <div style={{ fontFamily:'Syne,sans-serif', fontSize:15, fontWeight:700 }}>{f.titre}</div>
                <div style={{ color:'var(--muted)', fontSize:14, lineHeight:1.7 }}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── COMMENT ÇA MARCHE ── */}
      <div style={{ background:'var(--bg)' }}>
        <div style={{ padding: pSection, maxWidth:1240, margin:'0 auto' }}>
          <div style={{ display:'inline-flex', alignItems:'center', gap:8, color:'var(--accent2)', fontSize:11, fontWeight:600, letterSpacing:2, textTransform:'uppercase', marginBottom:14 }}>
            <span style={{ width:24, height:1, background:'var(--accent2)', display:'inline-block' }}/> Processus
          </div>
          <h2 style={{ fontFamily:'Syne,sans-serif', fontSize:'clamp(18px,2vw,26px)', fontWeight:800, lineHeight:1.1, letterSpacing:'-1.2px', marginBottom:24 }}>
            Comment ça marche
          </h2>
          <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill,minmax(300px,1fr))', gap:16 }}>
            {STEPS.map(s => (
              <div key={s.n} style={{ background:'var(--bg3)', border:'1px solid var(--border)', borderRadius:'var(--radius)', padding: isMobile ? '24px 20px' : '32px 28px', display:'flex', flexDirection:'column', gap:12, position:'relative', overflow:'hidden' }}>
                {/* Numéro décoratif en fond */}
                <div style={{ position:'absolute', top:-16, right:16, fontFamily:'Syne,sans-serif', fontWeight:800, fontSize:96, color:'var(--step-num)', pointerEvents:'none', lineHeight:1 }}>{s.n}</div>
                <div style={{ fontFamily:'Syne,sans-serif', fontSize:16, fontWeight:700 }}>{s.titre}</div>
                <div style={{ color:'var(--muted)', fontSize:14, lineHeight:1.7 }}>{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── CTA FINAL — inactif jusqu'à construction du module marque employeur ── */}
      <div style={{ padding: isMobile ? '40px 20px' : '60px 20px', textAlign:'center', background:`radial-gradient(ellipse 80% 60% at 50% 50%, var(--hero-cta) 0%, transparent 70%)`, borderTop:'1px solid var(--border)' }}>
        <h2 style={{ fontFamily:'Syne,sans-serif', fontSize:'clamp(20px,2.5vw,32px)', fontWeight:800, letterSpacing:'-1px', lineHeight:1.1, marginBottom:14 }}>
          Prêt à transformer votre recrutement ?
        </h2>
        <p style={{ color:'var(--muted)', fontSize: isMobile ? 14 : 16, marginBottom:28 }}>
          Rejoignez plus de 180 entreprises qui font confiance à {BRAND.name}.
        </p>
        <span onClick={() => navigate('/entreprise')} style={{ background:'var(--accent)', color:'#fff', padding: isMobile ? '14px 24px' : '16px 36px', borderRadius:10, fontSize: isMobile ? 14 : 16, fontWeight:500, display:'inline-flex', alignItems:'center', gap:8, boxShadow:'0 0 32px var(--glow)', cursor:'pointer' }}>
          {BRAND.cta} en 10 min <IconArrow/>
        </span>
      </div>

      {/* ── FOOTER ── */}
      <footer style={{ borderTop:'1px solid var(--border)', padding: isMobile ? '28px 20px' : '36px 64px', display:'flex', flexDirection: isMobile ? 'column' : 'row', justifyContent:'center', alignItems:'center', gap:40, color:'var(--muted)', fontSize:13, textAlign: isMobile ? 'center' : 'left' }}>
        <Logo height={28}/>

        {/* Liens footer — visibles uniquement sur mobile */}
        {isMobile && (
          <div style={{ display:'flex', gap:16, flexWrap:'wrap', justifyContent:'center' }}>
            {[
              { label:'Fonctionnalités', path:'/fonctionnalites' },
              { label:'Comment ça marche', path:'/comment-ca-marche' },
              { label:'Contact', path:'/contact' },
            ].map(l => (
              <span key={l.label} onClick={() => navigate(l.path)} style={{ color:'var(--muted)', cursor:'pointer' }}>{l.label}</span>
            ))}
          </div>
        )}
        <div>© {BRAND.year} {BRAND.name}</div>
      </footer>

    </div>
  );
}